import { normalizeAttributeName } from "../pages/admin/SellerAdmin/PIM/components/PIM.components.util";
import type {
  Fee,
  IFeesAndChargesSchema,
  SampleRequest,
  SampleRequestDetail,
} from "../types/types";

export const sampleRequestHasLinePricing = (
  items: Pick<SampleRequestDetail, "price_per_unit">[]
) =>
  items.some(
    (item) => item.price_per_unit != null && item.price_per_unit !== ""
  );

export const sampleRequestIsPriced = (sampleRequest: SampleRequest) =>
  Boolean(sampleRequest.enable_payments);

export const sampleRequestPaymentsEnabledForStorefront = (
  enable_payments_on_sample_requests?: boolean
) => Boolean(enable_payments_on_sample_requests);

export const get_fees_list = (
  charges_map: Record<string, IFeesAndChargesSchema> | undefined,
  fees: Fee[]
) => {
  return charges_map
    ? fees.map((fee) => {
        const fee_charge =
          charges_map[normalizeAttributeName(fee.name).toLowerCase()];
        if (fee_charge && Number(fee_charge.amount) === Number(fee.amount)) {
          return {
            ...fee,
            is_disabled: true,
          };
        }
        return { ...fee, is_disabled: false };
      })
    : fees.map((fee) => ({ ...fee, is_disabled: false }));
};
